import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
var selectStorageDomain = function (state) {
    return (state && state.storage) || getInitialState();
};
export var selectStorage = createSelector(selectStorageDomain, function (storage) { return storage; });
